<div *ngIf="shouldShowCheck" class="SelectionIndicator" [class.AnimateIn]="animationDirection === 'In'" [class.AnimateOut]="animationDirection === 'Out'" [class.Unavailable]="isUnavailable">
  <mat-icon *ngIf="!isUnavailable">check</mat-icon>
  <mat-icon *ngIf="isUnavailable" color="warn">error</mat-icon>
</div>